module.exports = __webpack_public_path__ + "static/media/fitness-centre.40a19938.png";